import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CuratedCombomark = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "148",
    height: "28",
    viewBox: "0 0 148 28"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#222",
    d: "M40 14.242c0 1.105.207 2.135.626 3.09.421.969.986 1.79 1.698 2.472a7.805 7.805 0 0 0 2.534 1.608 8.27 8.27 0 0 0 3.1.588c1.172 0 2.273-.24 3.31-.725a7.587 7.587 0 0 0 2.638-2.016l-1.83-1.59a5.15 5.15 0 0 1-1.823 1.378 5.439 5.439 0 0 1-2.296.495c-1.497 0-2.752-.506-3.75-1.514-1.004-1.001-1.504-2.26-1.504-3.786 0-1.525.5-2.784 1.504-3.803.998-1.012 2.253-1.515 3.75-1.515.808 0 1.563.158 2.263.481a5.53 5.53 0 0 1 1.813 1.357l1.852-1.597a7.916 7.916 0 0 0-2.639-1.988 7.816 7.816 0 0 0-3.289-.703c-1.455 0-2.784.337-4 .997a7.527 7.527 0 0 0-2.888 2.788C40.354 11.447 40 12.782 40 14.242zm18.098 1.726c0 .976.157 1.859.472 2.627.315.779.754 1.41 1.309 1.89a5.586 5.586 0 0 0 1.926 1.117 7.32 7.32 0 0 0 2.388.376c.851 0 1.645-.125 2.367-.376a5.619 5.619 0 0 0 1.92-1.116c.554-.48.983-1.112 1.297-1.891.304-.768.461-1.65.461-2.627V6.736h-2.702v8.956c0 1.295-.293 2.25-.89 2.881-.597.632-1.416.948-2.453.948-1.058 0-1.894-.316-2.491-.948-.597-.631-.901-1.586-.901-2.881V6.736h-2.703v9.232zm16.473 5.77h2.702V16.42h2.66l3.175 5.318h3.067l-3.621-5.981a4.28 4.28 0 0 0 1.977-1.662c.493-.768.743-1.629.743-2.605 0-.886-.218-1.693-.658-2.43a4.728 4.728 0 0 0-1.77-1.714 4.99 4.99 0 0 0-2.44-.61H74.57v15.002zm2.702-7.747V9.186h3.071c.637 0 1.173.22 1.602.664.418.442.63.998.63 1.68 0 .725-.223 1.313-.673 1.765-.45.463-1.048.696-1.77.696h-2.86zm11.36 7.747h2.856l1.33-2.881h6.431l1.309 2.881h2.903L96.058 6l-7.425 15.738zm5.216-5.235l2.188-4.837 2.188 4.837h-4.376zm15.777 5.235h2.703V9.186h4.054v-2.45h-10.818v2.45h4.061v12.552zm10.845-4.783c0 1.546.4 2.734 1.183 3.552.787.822 1.97 1.231 3.532 1.231h4.766v-2.45h-4.63c-.232 0-.46-.03-.683-.105a2.264 2.264 0 0 1-.69-.337 1.567 1.567 0 0 1-.554-.703c-.146-.316-.221-.693-.221-1.123v-1.852h6.198v-2.45h-6.198V9.185h6.631v-2.45h-9.334v10.219zm14.31 4.783h5.383c1.248 0 2.356-.18 3.353-.545.994-.37 1.812-.876 2.47-1.536a6.747 6.747 0 0 0 1.498-2.365c.347-.915.515-1.923.515-3.028s-.179-2.114-.525-3.029a6.942 6.942 0 0 0-1.499-2.386c-.657-.66-1.476-1.187-2.47-1.554-.997-.369-2.116-.56-3.364-.56h-5.362v15.003zm2.702-2.45V9.185h2.474c.961 0 1.801.126 2.502.377.7.255 1.244.61 1.655 1.073.408.474.7 1.001.901 1.6.186.6.282 1.281.282 2.028 0 .578-.053 1.116-.168 1.607a4.56 4.56 0 0 1-.575 1.378c-.261.43-.597.79-1.008 1.084-.408.305-.908.534-1.505.703-.608.169-1.302.251-2.067.251h-2.491z"
  }), React.createElement("path", {
    fill: "#434343",
    fillRule: "nonzero",
    d: "M2 2v24h24V2H2zM0 0h28v28H0V0z"
  })));
});

export default CuratedCombomark;
//# sourceMappingURL=curated-combomark.svg.js.map
